const shadows = {
  default: 'drop-shadow(8px 32px 32px rgba(0, 74, 131, 0.08))',
  medium: 'drop-shadow(4px 16px 32px rgba(3, 36, 62, 0.16))',
} as const;

export default shadows;

export type ThemeShadows = typeof shadows;
export type ThemeShadowsKeys = keyof typeof shadows;
